(function(){
  var GRID_ID='clz-review-grid';
  var built=false;

  function esc(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function buildGrid(){
    /* Find Judge.me review cards */
    var cards=document.querySelectorAll('.jdgm-rev');
    if(!cards.length) return false;

    /* Remove old grid if exists (pagination re-render) */
    var old=document.getElementById(GRID_ID);
    if(old) old.remove();

    /* Build cards HTML */
    var html='';
    cards.forEach(function(card){
      /* Stars */
      var stars=card.querySelectorAll('.jdgm-star');
      var starsHtml='<div class="clz-rc__stars">';
      stars.forEach(function(s){
        var on=s.classList.contains('jdgm--on')||s.classList.contains('jdgm--half');
        starsHtml+='<span class="clz-rc__star'+(on?' clz-rc__star--on':'')+'">&#9733;</span>';
      });
      starsHtml+='</div>';

      /* Title */
      var titleEl=card.querySelector('.jdgm-rev__title');
      var title=titleEl?titleEl.textContent.trim():'';

      /* Body */
      var bodyEl=card.querySelector('.jdgm-rev__body');
      var body=bodyEl?bodyEl.textContent.trim():'';

      /* Author */
      var authorEl=card.querySelector('.jdgm-rev__author-name')||card.querySelector('.jdgm-rev__author');
      var author=authorEl?authorEl.textContent.trim():'Anonymous';

      /* Date */
      var dateEl=card.querySelector('time')||card.querySelector('.jdgm-rev__timestamp');
      var date='';
      if(dateEl){
        var dt=dateEl.getAttribute('datetime')||dateEl.textContent.trim();
        try{ date=new Date(dt).toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}); }catch(e){ date=dt; }
      }

      /* Verified */
      var verified=!!card.querySelector('.jdgm-verified-badge');

      /* Image */
      var imgEl=card.querySelector('.jdgm-rev__pics img');
      var imgHtml=imgEl?'<img src="'+esc(imgEl.src)+'" class="clz-rc__img" loading="lazy" alt="">':'';

      html+='<div class="clz-rc">';
      html+=starsHtml;
      if(title) html+='<p class="clz-rc__title">'+esc(title)+'</p>';
      html+='<p class="clz-rc__body">'+esc(body)+'</p>';
      html+=imgHtml;
      html+='<div class="clz-rc__footer"><div>';
      html+='<span class="clz-rc__author">&mdash; '+esc(author)+'</span>';
      html+='<span class="clz-rc__date">'+esc(date)+'</span>';
      html+='</div>';
      if(verified) html+='<span class="clz-rc__badge">&#10003; Verified</span>';
      html+='</div></div>';
    });

    /* Create grid */
    var grid=document.createElement('div');
    grid.id=GRID_ID;
    grid.innerHTML='<div class="clz-rg-inner">'+html+'</div>';

    /* Insert before pagination or after the widget */
    var pag=document.querySelector('.jdgm-paginate');
    var widget=document.querySelector('#judgeme_product_reviews');
    if(pag && pag.parentNode){
      pag.parentNode.insertBefore(grid,pag);
    } else if(widget){
      widget.appendChild(grid);
    } else {
      document.body.appendChild(grid);
    }

    built=true;
    return true;
  }

  /* Poll until Judge.me renders */
  var tries=0;
  var iv=setInterval(function(){
    if(buildGrid()||tries++>80) clearInterval(iv);
  },250);

  /* Watch for pagination re-renders */
  if(window.MutationObserver){
    var ob=new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i++){
        if(mutations[i].addedNodes.length){
          /* Re-build grid after short delay to let Judge.me finish */
          setTimeout(buildGrid,300);
          break;
        }
      }
    });
    function startObs(){
      var w=document.querySelector('#judgeme_product_reviews');
      if(w) ob.observe(w,{childList:true,subtree:true});
    }
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',startObs);
    } else { startObs(); }
  }
})();
